import { Device } from '../helpers/Device'

export namespace Flooring {
  export const DEFAULT_DISPLAY_FLOOR = 0.50001
  export const DEFAULT_VIDEO_FLOOR = 8.0001

  export interface IFlooringGetter {
    (params: IFlooringParams): number
  }

  export interface IFlooringParams {
    country?: string
    device?: string
    os?: string
    isMobile?: boolean
  }

  export const getDisplayFloor: IFlooringGetter = ({
    country,
    device = Device.deviceType,
    os = Device.os
  }) => {
    if (!country) {
      return DEFAULT_DISPLAY_FLOOR
    }

    const normalizedDevice = DeviceMap[device] || DeviceMap.desktop
    const normalizedOS = OSMap[os] || OSMap.desktop
    const normalizedCountry = Country[country] || Country.US

    if (
      !flooringMap[normalizedCountry] ||
      !flooringMap[normalizedCountry][normalizedDevice] ||
      !flooringMap[normalizedCountry][normalizedDevice][normalizedOS]
    ) {
      return DEFAULT_DISPLAY_FLOOR
    }

    const floor = flooringMap[normalizedCountry][normalizedDevice][normalizedOS]

    return floor
  }

  export const getVideoFloor: IFlooringGetter = ({
    country,
    device = Device.deviceType,
    os = Device.os
  }) => {
    if (!country) {
      return DEFAULT_VIDEO_FLOOR
    }

    device = DeviceMap[Device.deviceType] || DeviceMap.desktop
    os = OSMap[Device.os] || OSMap.desktop
    const countryLookup = Country[country] || Country.INTL

    if (
      !videoFlooringMap[countryLookup] ||
      !videoFlooringMap[countryLookup][device] ||
      !videoFlooringMap[countryLookup][device][os]
    ) {
      return DEFAULT_VIDEO_FLOOR
    }
    const floor = videoFlooringMap[countryLookup][device][os]

    return floor
  }
}

export enum Country {
  US = 'US',
  INTL = 'INTL'
}

export enum OSMap {
  iOS = 'iOS',
  Android = 'Android',
  desktop = 'desktop'
}

export enum DeviceMap {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop'
}

type IFlooringMap = {
  [country in Country]: { [device in DeviceMap]: { [OS in OSMap]: number } }
}

// Values of 0.50001 shouldn't theoretically be hit.
// They represent an error in lookups, or
// an abnormal combination.
const flooringMap: IFlooringMap = {
  [Country.US]: {
    [DeviceMap.desktop]: {
      [OSMap.iOS]: 0.50001,
      [OSMap.Android]: 0.50001,
      [OSMap.desktop]: 0.6
    },
    [DeviceMap.mobile]: {
      [OSMap.iOS]: 0.22,
      [OSMap.Android]: 0.73,
      [OSMap.desktop]: 0.50001
    },
    [DeviceMap.tablet]: {
      [OSMap.iOS]: 0.26,
      [OSMap.Android]: 0.58,
      [OSMap.desktop]: 0.50001
    }
  },
  [Country.INTL]: {
    [DeviceMap.desktop]: {
      [OSMap.iOS]: 0.50001,
      [OSMap.Android]: 0.50001,
      [OSMap.desktop]: 0.25
    },
    [DeviceMap.mobile]: {
      [OSMap.iOS]: 0.1,
      [OSMap.Android]: 0.15,
      [OSMap.desktop]: 0.50001
    },
    [DeviceMap.tablet]: {
      [OSMap.iOS]: 0.15,
      [OSMap.Android]: 0.24,
      [OSMap.desktop]: 0.50001
    }
  }
}

const videoFlooringMap: IFlooringMap = {
  [Country.US]: {
    [DeviceMap.desktop]: {
      [OSMap.iOS]: 8.0001,
      [OSMap.Android]: 8.0001,
      [OSMap.desktop]: 6.5
    },
    [DeviceMap.mobile]: {
      [OSMap.iOS]: 2.0,
      [OSMap.Android]: 6.35,
      [OSMap.desktop]: 8.0001
    },
    [DeviceMap.tablet]: {
      [OSMap.iOS]: 2.91,
      [OSMap.Android]: 5.26,
      [OSMap.desktop]: 8.0001
    }
  },
  [Country.INTL]: {
    [DeviceMap.desktop]: {
      [OSMap.iOS]: 3.0001,
      [OSMap.Android]: 3.0001,
      [OSMap.desktop]: 2.0
    },
    [DeviceMap.mobile]: {
      [OSMap.iOS]: 2.0,
      [OSMap.Android]: 2.0,
      [OSMap.desktop]: 3.0001
    },
    [DeviceMap.tablet]: {
      [OSMap.iOS]: 2.0,
      [OSMap.Android]: 2.0,
      [OSMap.desktop]: 3.001
    }
  }
}
